import { z } from "zod";
import { CollectNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const collectNodeConsentFormSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.CONFIRMATION),
  label: z.string().min(1, "Label is required"),
  url: z.string().url("URL is invalid"),
});
